import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { TaxrateDto } from '../dtos';

export enum TaxratesActionTypes {
  LoadTaxrates = '[Taxrates] LoadTaxrates',
  LoadTaxratesSuccess = '[Taxrates] LoadTaxratesSuccess',
  LoadTaxratesError = '[Taxrates] LoadTaxratesError',
}

export const LoadTaxratesAction = createAction(TaxratesActionTypes.LoadTaxrates);
export const LoadTaxratesSuccessAction = createAction(TaxratesActionTypes.LoadTaxratesSuccess, props<{ taxrates: TaxrateDto[] }>());
export const LoadTaxratesErrorAction = createAction(TaxratesActionTypes.LoadTaxratesError, props<{ failure: AppStateFailure }>());
